// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blogCard {
  cursor: pointer;
}

.blogCard.column {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 2rem;
}

.blogCard__created {
  font-weight: 400;
  display: block;
  margin-top: 0.75rem;
}

.blogCard__description {
  font-weight: 200;
  line-height: 1.8;
  font-family: "Avenir Next";
}

.blogCard__title {
  font-size: 1.5rem;
  margin: 0.5rem 0;
  font-weight: 500;
}

.blogCard__img {
  border-radius: 1em;
  width: 100%;
  object-fit: cover;
  /* aspect-ratio: 3 / 2; */
}

@media (min-width: 768px) {
  .blogCard.featured {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
  }

  .blogCard.column .blogCard__img {
    border-radius: 1em;
    width: 100%;
    object-fit: cover;
    max-width: 25rem;
    height: 30rem;
    margin-right: 2rem;
  }

  .blogCard.column .blogCard__title {
    margin-bottom: 2rem;
  }

  .blogCard.column .blogCard__details {
    display: flex;
    flex-direction: column-reverse;
  }

  .blogCard.column .blogCard__created {
    color: var(--clr-gray500);
    text-transform: uppercase;
    font-size: 0.85rem;
    margin-top: 3rem;
  }
}

@media (min-width: 992px) {
  .blogCard.column {
    flex-direction: row;
    align-items: center;
  }

  .blogCard.featured {
    grid-column: 1 / -1;
    display: flex;
    max-width: unset;
    flex-direction: row;
  }

  .blogCard.featured .blogCard__created {
    margin-top: 0;
  }

  .blogCard.featured .blogCard__img {
    max-width: 35rem;
    width: 100%;
  }

  .blogCard.featured .blogCard__title {
    font-size: 3.125rem;
    line-height: 1.5;
  }

  .blogCard.featured .blogCard__details {
    margin-left: 3rem;
  }

  .blogCard.featured .blogCard__description {
    font-size: 1.25rem;
    display: flex;
    justify-self: flex-end;
    align-self: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BlogCard/BlogCard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".blogCard {\n  cursor: pointer;\n}\n\n.blogCard.column {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 2rem;\n}\n\n.blogCard__created {\n  font-weight: 400;\n  display: block;\n  margin-top: 0.75rem;\n}\n\n.blogCard__description {\n  font-weight: 200;\n  line-height: 1.8;\n  font-family: \"Avenir Next\";\n}\n\n.blogCard__title {\n  font-size: 1.5rem;\n  margin: 0.5rem 0;\n  font-weight: 500;\n}\n\n.blogCard__img {\n  border-radius: 1em;\n  width: 100%;\n  object-fit: cover;\n  /* aspect-ratio: 3 / 2; */\n}\n\n@media (min-width: 768px) {\n  .blogCard.featured {\n    grid-column: 1 / -1;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .blogCard.column .blogCard__img {\n    border-radius: 1em;\n    width: 100%;\n    object-fit: cover;\n    max-width: 25rem;\n    height: 30rem;\n    margin-right: 2rem;\n  }\n\n  .blogCard.column .blogCard__title {\n    margin-bottom: 2rem;\n  }\n\n  .blogCard.column .blogCard__details {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n\n  .blogCard.column .blogCard__created {\n    color: var(--clr-gray500);\n    text-transform: uppercase;\n    font-size: 0.85rem;\n    margin-top: 3rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .blogCard.column {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .blogCard.featured {\n    grid-column: 1 / -1;\n    display: flex;\n    max-width: unset;\n    flex-direction: row;\n  }\n\n  .blogCard.featured .blogCard__created {\n    margin-top: 0;\n  }\n\n  .blogCard.featured .blogCard__img {\n    max-width: 35rem;\n    width: 100%;\n  }\n\n  .blogCard.featured .blogCard__title {\n    font-size: 3.125rem;\n    line-height: 1.5;\n  }\n\n  .blogCard.featured .blogCard__details {\n    margin-left: 3rem;\n  }\n\n  .blogCard.featured .blogCard__description {\n    font-size: 1.25rem;\n    display: flex;\n    justify-self: flex-end;\n    align-self: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
